import "../style.css";
import React from 'react';
import PanelContent from "../components/PanelContent"

export default function Charge() {
  return (
    <PanelContent 
        id="autonomy_pannel"
        route="/autonomy"
        title="Maximiser l'énergie"
        subtitle="Le camion tire profit de chaque mètre"
        description="Grâce au système ERS, le camion se recharge en roulant. Sur le démonstrateur, quelques centaines de mètres de piste suffisent pour que le camion récupère plus d'énergie qu'il n'en utilise. Cette énergie stockée lui permet de continuer à circuler sans s'arrêter, garantissant un trajet fluide, même sur de longues distances."
        prev="/charge"
        next=""
        txtbtn="ÉTAPE SUIVANTE"
    />
  );
}